module.exports = __webpack_public_path__ + "img/kg.d35765ff.svg";